const breakpoints = {
    xs: '490',
    // xs: '480', original
    sm: '768',
    md: '992',
    lg: '1200',
    xl: '1600'
};
// width

export default breakpoints;